'use client';

import type { PromptBarMode } from './usePromptBarMode';
import { MissionChipsRow } from './MissionChipsRow';
import { PromptBarScrim } from './PromptBarScrim';

interface PromptBarChipsProps {
  locale: Locale;
  mode: PromptBarMode;
  isAuthenticated: boolean;
  /** Render in document flow instead of fixed-position overlay. */
  inline?: boolean;
}

/**
 * Company-page navigation surface: the mission list as a centered row of chips. Replaces
 * the prompt bar on surfaces where the prompt input is not useful.
 */
export const PromptBarChips = ({ locale, mode, isAuthenticated, inline = false }: PromptBarChipsProps) => {
  const chipsRow = <MissionChipsRow locale={locale} mode={mode} isAuthenticated={isAuthenticated} />;

  if (inline) {
    return <div className="flex w-full justify-center">{chipsRow}</div>;
  }

  return (
    <>
      <PromptBarScrim />
      <div
        className="fixed inset-x-0 bottom-3 z-30 flex justify-center lg:bottom-8"
        style={{ paddingLeft: 'var(--two-column-header-offset, 0px)' }}
      >
        {chipsRow}
      </div>
    </>
  );
};
